import { returnResult } from "@/utils/helpers";
import { ICallApi, ISetState } from "../../call-api.interface";

const getAndSetAllEmployees = async (
  callApi: ICallApi,
  setState?: ISetState,
  data?: any,
  lockScreen: boolean = true
) => {
  const result: any = await callApi(
    "GET",
    "/v1/crm-service/employee/get-all-employees",
    data,
    lockScreen
  );
  return returnResult(result, setState);
};

export { getAndSetAllEmployees };
